module.exports = __webpack_public_path__ + "img/no-staff.7c793bf9.svg";